import CONSTANTS from './constants';
import * as SELECTORS from './selectors';
import {getTableFilterData, applyTableFilter, loadMoreFilter} from '../../api';
import * as filterUtils from '@/common/utils/Tables/filters';
import * as tablesActions from './tables';

const {
	initialState,
	ACTION_NAMES
} = CONSTANTS;

/** ACTIONS **/
const updateFilters = ({filters, questionId}) => {
  return {
	type: ACTION_NAMES.FILTERS_UPDATE,
	filters: [...filters],
	questionId
  }
};

const applyFilterSuccess = (params) => {
  return {
	type: ACTION_NAMES.FILTER_APPLY_SUCCESS,
	...params
  }
};

const hideFiltersInAllTables = () => {
  return {
	type: ACTION_NAMES.FILTERS_HIDE_IN_ALL_TABLES
  }
};

export const loadMoreFilterData = ({questionId, chunkSize, lastFilterItemIndex, columnId, isSelectAll, selectAllChanged, searchQuery}) => {
  return (dispatch, getState) => {
	let filters = SELECTORS.getQuestionTableFilters({state: getState(), questionId});

	filters = filterUtils.setFilterLoadingValue({filters, columnId, value: true});
	dispatch(updateFilters({filters, questionId}));

	loadMoreFilter({
	  questionId,
	  chunkSize,
	  lastFilterItemIndex,
	  columnId,
	  isSelectAll,
	  selectAllChanged,
	  searchQuery
	}).then((result) => {
	  filters = SELECTORS.getQuestionTableFilters({state: getState(), questionId});

	  let {data} = result;
	  let filterObject = {...filterUtils.getFilterByColumnId(columnId, filters)};
	  const clientFilterObject = {...filterUtils.serverObjectToClient(filterObject, data)};
	  const newOptions = filterObject.options.concat(clientFilterObject.options);

	  clientFilterObject.options = [...newOptions];

	  filters = filterUtils.overwriteFilter(clientFilterObject, filters);
	  filters = filterUtils.setFilterLoadingValue({filters, columnId, value: false});
	  dispatch(updateFilters({filters, questionId}));
	});
  };
};


export const toggleFilter = ({questionId, columnId}) => {
  return (dispatch, getState) => {
	let state = getState();
	let filters = [...SELECTORS.getQuestionTableFilters({state, questionId})];
	const isFilterExists = filterUtils.isFilterInArray(columnId, filters);
	const filterObject = isFilterExists ? filterUtils.getFilterByColumnId(columnId, filters) : filterUtils.getFilterObject(columnId);

	if (!isFilterExists) {
	  filters.push({...filterObject});
	  //console.log('filter added: ', filterObject, filters);
	}

	dispatch(updateFilters({filters, questionId}));

	if (!filterObject.visible) {
	  dispatch(hideFiltersInAllTables());
	}

	state = getState();
	filters = [...SELECTORS.getQuestionTableFilters({state, questionId})];
	const newFiltersArray = filterUtils.setFilterVisibleValue({filters, columnId, value: !filterObject.visible});

	//console.log('Getting filters for questions: ', state, questionId);

	dispatch(updateFilters({filters: [...newFiltersArray], questionId}));
  };
};

export const loadFilterData = ({questionId, columnId, searchQuery}) => {
  return (dispatch, getState) => {
	let state = getState();
	let filters = [...SELECTORS.getQuestionTableFilters({state, questionId})];
	let newFiltersArray = filterUtils.setFilterLoadingValue({filters, columnId, value: true});

	const params = {
	  questionId,
	  columnId
	};

	if (searchQuery && searchQuery.length > 0) {
	  params.searchQuery = searchQuery;
	}

	dispatch(updateFilters({filters: [...newFiltersArray], questionId}));

	//console.log('Getting filter for: ', questionId, columnId, searchQuery, filters);

	getTableFilterData(params)
		.then((result) => {
		  let {data} = result;
		  state = getState();
		  //console.log('Filter from server: ', data);
		  //console.log('Filter on client: ', filterObject);

		  filters = [...SELECTORS.getQuestionTableFilters({state, questionId})];

		  const isError = !data.hasOwnProperty('title');
		  const filterObject = {...filterUtils.getFilterByColumnId(columnId, filters)};


		  filterObject.error = isError;


		  const clientFilterObject = {...filterUtils.serverObjectToClient(filterObject, data)};


		  filters = filterUtils.overwriteFilter(clientFilterObject, filters);
		  filters = filterUtils.setFilterLoadingValue({filters, columnId, value: false});


		  dispatch(updateFilters({filters, questionId}));
		});
  };
};

export const applyFilter = ({questionId, filter, isSelectAll, selectAllChanged}) => {
  //console.log('Opachki...');
  return (dispatch, getState) => {
	//console.log('Trying not to obosratsa');
	const {isMultichoiceFilterType, isRangeFilterType, clientObjectToServer} = filterUtils;
	const {columnId} = filter;
	let dataObject = {};

	if (isMultichoiceFilterType(columnId)) {
	  dataObject = clientObjectToServer(filter, {});
	  dataObject.isSelectAll = isSelectAll;
	  dataObject.selectAllChanged = selectAllChanged;
	} else if (isRangeFilterType(columnId)) {
	  dataObject = clientObjectToServer(filter, {});
	}


	const serverParams = {
	  questionId,
	  columnFilters: [
		{
		  data: JSON.stringify(dataObject),
		  name: columnId.toUpperCase()
		}
	  ]
	};

	dispatch(toggleFilter({questionId, columnId}));
	dispatch(tablesActions.tableDataLoadStart(questionId));

	applyTableFilter(serverParams).then((response) => {
	  const {data} = response;
	  /*console.log('Filter applied.');
	  console.log('Data from server: ', data);

	  console.log('Reloading data');*/

	  const tableState = SELECTORS.getTableForQuestion({state: getState(), questionId});

	  const {hasMoreData, body} = data;

	  dispatch(applyFilterSuccess({questionId, data: body, lastRowIndex: tableState.chunkSize + 1, hasMoreData}));
	  tablesActions.onDataLoadedJquery({firstLoad: false, questionId});
	});
  };
};

export const searchInFilter = ({questionId, searchQuery, columnId}) => {
  return (dispatch, getState) => {
	let state = getState();
	let filters = SELECTORS.getQuestionTableFilters({state, questionId});
	filters = filterUtils.setFilterLoadingValue({filters, questionId, columnId});

	//console.log('Searching filter: ', questionId, searchQuery, columnId);

	dispatch(updateFilters({filters, questionId}));
	dispatch(loadFilterData({questionId, searchQuery, columnId}));
  };
};
/** ACTIONS END **/

/** REDUCER HELPERS **/
const onTableFiltersUpdate = (state, action) => {
  const {filters, questionId} = action;
  const tableState = {...state[questionId]};

  tableState.filters = [...filters];

  //console.log('Updating filters: ', tableState);

  return {
	...state,
	[questionId]: {
	  ...tableState
	}
  }
};

const onFilterApplySuccess = (state, action) => {
  const {questionId, ...tableParams} = action;
  const tableState = {
	...state[questionId],
	...tableParams,
	loadingData: false
  };


  return {
	...state,
	[questionId]: {
	  ...tableState
	}
  }
};

const onHideFiltersInAllTables = (state) => {
  const stateClone = {...state};

  //console.log('State clone: ', stateClone);
  //console.log('Keys: ', Object.keys(stateClone));

  Object.keys(stateClone).forEach((key, idx) => {
	//console.log(key, idx);
	const tableStateClone = {...stateClone[key]};
	const {filters} = {...stateClone[key]};

	//console.log('filters: ', filters);

	let shouldHide = filters.filter((filter) => {
		  return filter.visible === true;
		}).length > 0;

	if (shouldHide) {
	  tableStateClone.filters = filterUtils.hideAllFilters({filters});

	  stateClone[key] = {...tableStateClone};
	}
  });

  return stateClone;
};
/** REDUCER HELPERS END **/

/** REDUCER **/
export default (state = initialState, action) => {
  switch (action.type) {
	case ACTION_NAMES.FILTERS_UPDATE:
	  return onTableFiltersUpdate(state, action);
	case ACTION_NAMES.FILTERS_HIDE_IN_ALL_TABLES:
	  return onHideFiltersInAllTables(state, action);
	case ACTION_NAMES.FILTER_APPLY_SUCCESS:
	  return onFilterApplySuccess(state, action);
	default:
	  return state;
  }
};
/** REDUCER END **/



// WEBPACK FOOTER //
// ./components/qual/Table/ducks/filters.js